import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import * as itemActions from 'tradera/state/items/actions';
import { useDispatch } from 'react-redux';
import { itemStates } from './item-states';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import { Button } from '../atoms/button/button';

export const ActionButton = ({ item }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const dispatch = useDispatch();

    const trackGoToVip = () => {
        GtmService.trackAction('My Tradera', 'Wishlist', 'Go to VIP');
    };

    switch (item.itemState) {
        case itemStates.bidderActiveLeading:
            return (
                <Button
                    theme="primary"
                    fluid
                    href={toLocalizedUrl(item.itemUrl)}
                    onClick={trackGoToVip}>
                    {t('myt_actions_listItemRaiseMaxBidAction')}
                </Button>
            );
        case itemStates.bidderActiveReservedPriceNotReached:
        case itemStates.bidderActiveOverbidden:
        case itemStates.generalActive:
            return (
                <Button
                    theme="primary"
                    fluid
                    href={toLocalizedUrl(item.itemUrl)}
                    onClick={trackGoToVip}>
                    {t('myt_actions_listItemBidAction')}
                </Button>
            );
        case itemStates.buyItNowActive:
        case itemStates.shopItemActive:
            return (
                <Button
                    theme="primary"
                    fluid
                    href={toLocalizedUrl(item.itemUrl)}
                    onClick={trackGoToVip}>
                    {t('myt_actions_listItemBuyAction')}
                </Button>
            );
        case itemStates.bidderAuctionRemoved:
        case itemStates.bidderBidRemoved:
        case itemStates.bidderEndedReservedPriceNotReached:
        case itemStates.bidderEndedNotWon:
        case itemStates.buyItNowEnded:
        case itemStates.generalEnded:
        case itemStates.shopItemEnded:
            return (
                <Button
                    theme="primary"
                    variant="outline"
                    fluid
                    onClick={() =>
                        dispatch(itemActions.wishlist(item.itemId, false))
                    }>
                    {t('myt_actions_listItemWishListDeleteAction')}
                </Button>
            );
        case itemStates.bidderEndedWon:
        case itemStates.shopItemEndedWon:
        case itemStates.buyItNowEndedWon:
            return (
                <Button
                    theme="primary"
                    variant="outline"
                    fluid
                    href={toLocalizedUrl('/my/purchases')}>
                    {t('myt_actions_listGotoPurchasesAction')}
                </Button>
            );
        default:
            throw new Error('Unknown item state');
    }
};
